import PricingTable from '../components/PricingTable'
import { useEffect } from "react";

const StripePricing = (): JSX.Element => {
  useEffect(() => {
      document.title = "Pricing Table";
    }, []);
  return (
    <div id='pricing-table'>
      <PricingTable />
    </div>
  );
};

export default StripePricing;
